import React from 'react'
import { Form } from 'antd'

import { toStringEqual } from '@/utils/utils'

export default React.memo(({ onUpdate }) => {
    return (
        <Form.Item
            noStyle
            shouldUpdate={(prevValues, curValues) => {
                return !toStringEqual(
                    prevValues?.aiFullField?.aiFullImagesList,
                    curValues?.aiFullField?.aiFullImagesList
                )
            }}
        >
            {({ getFieldValue }) => {
                const aiFullImagesList = getFieldValue(['aiFullField', 'aiFullImagesList']) || []
                onUpdate(aiFullImagesList)

                return null
            }}
        </Form.Item>
    )
})
